import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Folder, Grid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import type { WorkspaceItem } from '@/store/reducers/dashboard/types'

interface Props {
  folders: WorkspaceItem[]
}

export const WorkspaceFolders: React.FC<Props> = ({ folders }) => {
  const actualFolders = folders.filter((f) => f.type === 'folder')

  return (
    <>
      <DropdownMenu.Button icon={Grid} id="" title="Dashboard" />
      {actualFolders.map(({ id, title }) => (
        <DropdownMenu.Button icon={Folder} key={id} id={id} title={title} />
      ))}
    </>
  )
}
